!customElements.get('atc-ref-btn') && customElements.define("atc-ref-btn", class extends HTMLElement {
    connectedCallback () {
        this.button = this.querySelector("button[type='submit']");
        this.formSelector = this.dataset.formSelector;
        this.form = this.formSelector ? document.querySelector(this.dataset.formSelector) : this.button?.form;
        this.pubsubEvents = typeof PUB_SUB_EVENTS !== "undefined" ? PUB_SUB_EVENTS : {};
        this.isLoading = false;

        this.unsubscribeCartUpdate = window.subscribe ? window.subscribe(this.pubsubEvents.cartUpdate, () => {
            this.setLoadingState(false);
        }) : null;

        this.unsubscribeCartError = window.subscribe ? window.subscribe(this.pubsubEvents.cartError, () => {
            this.setLoadingState(false);
        }) : null;

        this.button?.addEventListener("click", this.buttonClickHandler);
        this.updateButtonListener();
    }

    disconnectedCallback () {
        this.disconnectATC();
    }

    disconnectATC () {
        this.button?.removeEventListener("click", this.buttonClickHandler);
        typeof this.unsubscribeCartUpdate === "function" && this.unsubscribeCartUpdate();
        typeof this.unsubscribeCartError === "function" && this.unsubscribeCartError();
    }

    updateButtonListener () {
        subscribe("select-lenses", (e) => {
            this.disconnectATC();
            if(this.button) {
                this.button.textContent = e.copy;
                this.button.addEventListener("click", (e) => {
                    e.preventDefault();
                    document.querySelector("[name='rxc-activator']")?.click();
                    if (!this.isLoading)
                        this.setLoadingState(true);
                })
            }
        })

        subscribe("frame-loaded", () => this.setLoadingState(false));
    }

    buttonClickHandler = (event) => {
        if (!this.form?.isConnected) {
            this.form = this.formSelector ? document.querySelector(this.dataset.formSelector) : this.button?.form;
        }

        if (!this.form) {
            console.error("No form found:", this.dataset.formSelector);
            return;
        }

        event.preventDefault();

        if (!this.isLoading) {
            this.setLoadingState(true);
            this.submitForm();
        }
    }

    submitForm () {
        const submitBtn = this.form?.querySelector("[type='submit']");

        if (submitBtn) {
            submitBtn.click();
        } else if (this.form?.requestSubmit) {
            this.form.requestSubmit();
        }
    }

    setLoadingState (isLoading) {
        if (this.button) {
            this.button.toggleAttribute("data-loading", isLoading)
            this.button.ariaDisabled = isLoading;
        }

        this.isLoading = isLoading;
    }
});